import { createCookie, eraseCookie } from "./Global";
import { get } from "./WebService";
import { API_BASE, BASE_URL_UI } from "../config";
import {navigate} from"../Utils/Global"

/** Set cookie customization if exist */
export const setCookieToLoginCustomization = customization => {
  if (!customization) {
    return;
  }

  // escape nulls
  for (let key in customization) {
    if (customization[key] === null) {
      customization[key] = "";
    }
  }
  
  const jsonString = JSON.stringify(customization);
  const encodedJson = encodeURIComponent(jsonString);

  eraseCookie("loginCustomization", "/vispeahen/ui");
  
  createCookie(
    "loginCustomization",
    encodedJson,
    null,
    "/"
  );
};

/**
 * Get user settings for login settings.
 * Cookies are set by these settings.
 */
export const getCustomization = (token, doNavigateRedirectUrl = false) => {
  let url = `${API_BASE}/loginCustomization`;

  //GET loginCustomization and save it to the cookie for future usage purposes
  const successFunc = result => {
    setCookieToLoginCustomization(result.data);
    
    if (doNavigateRedirectUrl) {
      const redirectUrl =  result.data?.redirectUrl? result.data.redirectUrl : BASE_URL_UI
      navigate(redirectUrl);
    }
  };

  get(url, successFunc, undefined, false, false, undefined);
};

export const getCustomizationAndNavigate = (token) => {

  let url = `${API_BASE}/loginCustomization`;
  //GET loginCustomization and save it to the cookie for future usage purposes
  const successFunc = result => {
    setCookieToLoginCustomization(result.data);
    const redirectUrl =  result.data?.defaultUrl? result.data.defaultUrl : BASE_URL_UI
    navigate(redirectUrl);
 };

  get(url, successFunc, undefined, false, false);
};